<template>
  <div v-if="render" class="page-box">
    <div class="back-box" @click="back">
      <i class="fas fa-chevron-left fa-fw"></i>
      BACK
    </div>

    <div class="bread-box d-flex align-center">
      <span @click="back">{{ locationLabel }}</span>
      <i class="fas fa-chevron-right fa-fw"></i>
      <span>Activities</span>
    </div>

    <div class="page-title-box">Theater, shows & musicals</div>

    <div class="filter-box d-flex justify-space-between align-center">
      <div class="pills-box d-flex flex-wrap">
        <div :class="['pill-lr d-flex align-center', {disabled:things.filter.categories.indexOf(x) === -1}]" v-for="x in things.categories" @click="toggleCategory(x)">
          <span>{{ x }}</span>
          <i class="fas fa-times"></i>
        </div>
      </div>
      <div class="rd-field-box">
        <label>Sort by - {{ sort }}</label>
        <select v-model="sort">
          <option value="lowToHigh">Price: low to high</option>
          <option value="highToLow">Price: high to low</option>
        </select>
      </div>
    </div>

    <div class="things-list d-flex flex-wrap">
      <div class="tl-box d-flex flex-column" v-for="act in activities" @click="view(act)">
        <div class="tl-img" :style="{'background-image':'url(' + act.ImageUrl + ')'}"></div>
        <div class="tl-info d-flex flex-column flex-grow-1 justify-space-between">
          <div>
            <div class="tl-title">{{ act.ProductName }}</div>
            <div class="tl-duration d-flex align-center" v-if="act.Duration">
              <i class="fas fa-clock fa-fw"></i>
              <span>{{ act.Duration }}</span>
            </div>
            <div class="d-flex align-start rating-box" v-if="act.StarRating">
              <div class="tl-rating">{{ act.StarRating }}</div>
              <div class="tl-rating-text d-flex flex-column">
                <!-- <div class="rating-text">{{ act.ratingText }}</div> -->
                <div class="review">{{ act.ReviewCount }}</div>
              </div>
            </div>
          </div>
          <div>
            <div class="tl-price">${{ discount(act.Price, 35).discounted }}</div>
            <!-- <div class="tl-price">${{ (act.Price.TotalDisplayFare / currency.list[act.Price.Currency]).toFixed(2) }}</div> -->
            <div class="tl-tax">{{ act.priceIncludes || 'includes taxes & fees per adult' }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import currencySymbol from '@/data/currency.js'

export default {
  data () {
    return {
      render: false,
      currencySymbol: currencySymbol
    }
  },
  computed: {
    things () { return this.$store.state.things },
    sort: {
      get () { return this.things.sort },
      set (x) { this.$store.commit('things/setThingsData', {sort: x}) }
    },
    locationLabel () {
      if (!this.things.location.selected) return ''
      return `${this.things.location.selected.destinationName}, ${this.things.location.selected.countryName}`
    },
    activities () {
      // const filtered = this.things.list.filter(item => {
      //   if (!item.Sub_Cat_Ids) return false
      //   return Object.values(item.Sub_Cat_Ids).includes(searchKey)
      // })

      const list = this.things.list
      const allowedCategories = this.things.filter.categories

      let filtered = list.filter(item => {
        if (!item.Sub_Cat_Ids) return false
        const subCategories = Object.values(item.Sub_Cat_Ids)
        return subCategories.some(cat => allowedCategories.includes(cat))
      })
      if (this.sort === 'lowToHigh') filtered = filtered.sort((a, b) => a.Price.TotalDisplayFare - b.Price.TotalDisplayFare)
      else filtered = filtered.sort((a, b) => b.Price.TotalDisplayFare - a.Price.TotalDisplayFare)
      return filtered
      // return this.things.list
    },
    currency () { return this.$store.state.other.currency }
  },
  methods: {
    back () {
      this.$router.push('/search')
    },
    toggleCategory (x) {
      this.$store.commit('things/toggleFilterCategory', x)
    },
    view (x) {
      let self = this
      this.$store.commit('global/setLoaderData', {show: true})
      self.$sdk.post2(`${CONFIG.d2dAPI}/sightseeing/provider1/product-details`, {
        ProductCode: x.ProductCode,
        ResultToken: x.ResultToken
      }, r => {
        if (!r.Status) {
          self.$store.commit('global/setLoaderData', {show: false})
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.Message
          })
          return
        }
        self.$store.commit('things/setThingsData', {view: r.ProductDetails.SSInfoResult})
        self.$router.push('things/view')
      })
    },
    discount (data, x) {
      let price = data.TotalDisplayFare / this.currency.list[data.Currency]
      let discount = price * (x / 100)
      return {
        price: price.toFixed(2),
        discount: discount.toFixed(2),
        discounted: (price - discount).toFixed(2)
      }
    }
  },
  mounted () {
    this.render = false
    if (!this.things.location.selected || !Object.keys(this.things.location.selected).length) {
      this.back()
      return
    }
    this.render = true
    this.$store.commit('global/setLoaderData', {show: false})
  }
}
</script>

<style lang="scss" scoped>
.page-box{
  padding-bottom: 30px;
}
.back-box{
  color: #ff9c09;
  letter-spacing: .7px;
  margin-bottom: 20px;
  cursor: pointer;
}

.bread-box{
  font-size: 12px;
  gap: 10px;
  margin-bottom: 5px;
}

.page-title-box{
  font-weight: 600;
  font-size: 36px;
  letter-spacing: .7px;
  line-height: 1;
  margin-bottom: 20px;
}

.filter-box{
  margin-bottom: 20px;
}
.pills-box{
  gap: 10px;
  width: calc(100% - 220px);
}
.pill-lr{
  background: #586776;
  color: #fff;
  gap: 7px;
  font-size: 13px;
  line-height: 1;
  letter-spacing: .7px;
  padding: 5px 7px 4px;
  border-radius: 3px;
  cursor: pointer;
  transition: all .2s ease;

  i{
    color: #ff9e9e;
  }
  &.disabled{
    background: #92a3b4;

    i{
      color: #ffbaba;
    }
  }
}
.rd-field-box{
  background: #fff;
  border: 2px solid #CCD0E2;
  border-radius: 4px;
  line-height: 1;
  padding: 7px 10px 10px;

  label{
    display: block;
    color: #6c7c8f;
    font-size: 12px;
    margin-bottom: 2px;
  }
  select{
    padding: 0;
    width: 180px;
    border: none;
    outline: none;
    font-size: 17px;
    line-height: 1;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}

.things-list{
  gap: 20px;
}

.tl-box{
  flex: 0 0 280px;
  border: 2px solid #777;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  transition: all .2s ease;

  &:hover{
    box-shadow: 0 0 4px 1px rgba(0, 0, 0, .3);
    border-color: #333;
  }
}
.tl-img{
  background-color: #f8f8f8;
  background-size: cover;
  background-position: center center;
  width: 280px;
  height: 200px;
}
.tl-info {
  background: #fff;
  padding: 10px 0;
}
.tl-title{
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: .6px;
  margin-bottom: 8px;
  padding: 0 10px;
}
.tl-duration{
  padding: 0 10px;
  line-height: 1;
  color: #95a5b5;

  i{
    margin-right: 5px;
    font-size: 14px;
  }
  span{
    font-size: 13px;
    letter-spacing: .7px;
  }
}
.rating-box{
  padding: 0 10px;
  letter-spacing: .6px;
}
.tl-rating{
  font-size: 15px;
  font-weight: 600;
  line-height: 1;
  padding: 7px 10px;
  margin-right: 10px;
  background: #1d9c23;
  color: #fff;
}
.tl-rating-text{
  line-height: 1;
  font-size: 12px;
}
.rating-text{
  margin-bottom: 5px;
}
.tl-price{
  padding: 0 10px;
  font-size: 28px;
  font-weight: 600;
  letter-spacing: .7px;
  margin: 20px 0 2px;
  line-height: 1;
}
.tl-tax{
  padding: 0 10px;
  font-size: 11px;
  font-style: italic;
  letter-spacing: .7px;
  line-height: 1;
}

@media only screen and (max-width: 641px) {
  .page-box{
    padding: 0 20px;
  }
  .bread-box{
    font-size: 14px;
    margin-bottom: 10px;
    letter-spacing: .6px;
  }
  .filter-box{
    flex-direction: column;
    align-items: start;
    gap: 20px;
    margin-bottom: 30px;
  }
  .tl-box{
    flex: 0 0 calc(50% - 10px);
  }
}
</style>


// WEBPACK FOOTER //
// index.vue?0cceb770